export default __webpack_public_path__ + "static/media/3.1b1b4d97.png";